import React, { useRef, useState } from 'react';

export const TableSkeleton = ({
  rowCount = 5,
  columnCount = 4,
  label = '加载中'
}) => (
  <div
    className="skeleton-table"
    role="status"
    aria-label={label}
    style={{ '--skeleton-columns': columnCount }}
  >
    {Array.from({ length: rowCount }, (_, rowIndex) => (
      <div className="skeleton-table-row" key={rowIndex}>
        {Array.from({ length: columnCount }, (_, columnIndex) => (
          <span className="skeleton-cell" key={columnIndex} />
        ))}
      </div>
    ))}
  </div>
);

export const PageSkeleton = ({
  metricCount = 0,
  rowCount = 4,
  columnCount = 3,
  label = '加载中'
}) => (
  <div className="page-skeleton" role="status" aria-label={label}>
    {metricCount > 0 && (
      <div className="skeleton-metrics">
        {Array.from({ length: metricCount }, (_, index) => (
          <span className="skeleton-metric" key={index} />
        ))}
      </div>
    )}
    <TableSkeleton rowCount={rowCount} columnCount={columnCount} label={label} />
  </div>
);

export const InlineLoading = ({ label = '处理中...' }) => (
  <span className="inline-loading" role="status">
    <span className="inline-loading-spinner" aria-hidden="true" />
    {label}
  </span>
);

export const EmptyState = ({ title, description, action }) => (
  <div className="feedback-state feedback-empty">
    <strong>{title}</strong>
    {description && <span>{description}</span>}
    {action}
  </div>
);

export const ErrorState = ({
  title = '加载失败',
  description,
  onRetry,
  retryLabel = '重试'
}) => {
  const [isRetrying, setIsRetrying] = useState(false);
  const retryInFlight = useRef(false);

  const handleRetry = () => {
    if (!onRetry || retryInFlight.current) {
      return;
    }

    retryInFlight.current = true;
    setIsRetrying(true);
    let retryResult;

    try {
      retryResult = onRetry();
    } catch (error) {
      retryInFlight.current = false;
      setIsRetrying(false);
      return;
    }

    Promise.resolve(retryResult)
      .catch(() => {})
      .finally(() => {
        retryInFlight.current = false;
        setIsRetrying(false);
      });
  };

  return (
    <div className="feedback-state feedback-error" role="alert">
      <strong>{title}</strong>
      {description && <span>{description}</span>}
      {onRetry && (
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={isRetrying}
          onClick={handleRetry}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
};
